/**
 * Browser-safe env reader.
 * Bun inlines literal `process.env.FOO` references in client bundles at build/serve time,
 * so we MUST use full static literals below (no dynamic keys, no aliasing).
 *
 * Resolution order for each var:
 *   1. window.__ENV__ (runtime override from index.html — useful per-deploy)
 *   2. process.env.VAR (inlined by Bun from .env at build time)
 *   3. "" fallback
 *
 * Empty strings from runtime.__ENV__ are treated as unset.
 */

const runtime: Record<string, string | undefined> =
  (typeof window !== "undefined" && (window as any).__ENV__) || {};

const pick = (...vals: (string | undefined)[]): string => {
  for (const v of vals) if (v && v.length > 0) return v;
  return "";
};

// Each `process.env.X` below is a LITERAL so Bun inlines it into the client bundle.
// Wrap in try to survive SSR / missing process.
let pSupabaseUrl: string | undefined;
let pSupabaseUrlVite: string | undefined;
let pSupabaseKey: string | undefined;
let pSupabaseKeyVite1: string | undefined;
let pSupabaseKeyVite2: string | undefined;
let pPostHogKey: string | undefined;
let pPostHogToken: string | undefined;
let pPostHogHost: string | undefined;

try {
  // @ts-ignore
  pSupabaseUrl = process.env.SUPABASE_URL;
  // @ts-ignore
  pSupabaseUrlVite = process.env.VITE_SUPABASE_URL;
  // @ts-ignore
  pSupabaseKey = process.env.SUPABASE_ANON_KEY;
  // @ts-ignore
  pSupabaseKeyVite1 = process.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  // @ts-ignore
  pSupabaseKeyVite2 = process.env.VITE_SUPABASE_ANON_KEY;
  // @ts-ignore
  pPostHogKey = process.env.POSTHOG_KEY;
  // @ts-ignore
  pPostHogToken = process.env.POSTHOG_PROJECT_TOKEN;
  // @ts-ignore
  pPostHogHost = process.env.POSTHOG_HOST;
} catch {}

export const ENV = {
  SUPABASE_URL: pick(runtime.SUPABASE_URL, runtime.VITE_SUPABASE_URL, pSupabaseUrl, pSupabaseUrlVite),
  SUPABASE_ANON_KEY: pick(
    runtime.SUPABASE_ANON_KEY,
    runtime.VITE_SUPABASE_PUBLISHABLE_KEY,
    runtime.VITE_SUPABASE_ANON_KEY,
    pSupabaseKey,
    pSupabaseKeyVite1,
    pSupabaseKeyVite2,
  ),
  POSTHOG_KEY: pick(runtime.POSTHOG_KEY, runtime.POSTHOG_PROJECT_TOKEN, pPostHogKey, pPostHogToken),
  POSTHOG_HOST: pick(runtime.POSTHOG_HOST, pPostHogHost, "https://us.i.posthog.com"),
};
